import { render, staticRenderFns } from "./SummaryOrderCard.vue?vue&type=template&id=47076fca&scoped=true&"
import script from "./SummaryOrderCard.vue?vue&type=script&lang=js&"
export * from "./SummaryOrderCard.vue?vue&type=script&lang=js&"
import style0 from "./SummaryOrderCard.vue?vue&type=style&index=0&id=47076fca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47076fca",
  null
  
)

export default component.exports